import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'reza-error-page',
  host: { class: 'block py-15 text-center' },
  templateUrl: './error-page.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorPageComponent {
  @Input()
  errorTitle: string | null = null;

  @Input()
  perex: string | null = null;

  @Input()
  text: string | null = null;

  @Input()
  image: string | null = null;
}
